// extracted by mini-css-extract-plugin
export default {"container":"Years_container__-vLte","label":"Years_label__9+wYr"};